/* globals Store */
import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {UploadFile} from '@/vue-dlb/models'
import {DownloadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';
import { compareSort } from '@/vue-dlb/common/common';

import {
  handleResponseError,
  alertSuccess,
  closeAlert,
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  mainGrid: [],
  arrFilter: [],
  genMapFlag: '',
  mainGridSource: [],
  statusList: [],
  mapList: [],
  mapFixed: [],
  appliedList: [],
  atftList: [],
  atftRepoList: [],
  ffList: [],
};

const getters = {
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mainGrid");
    const retSet2 = new ObjDataSet("statusList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_SRM_LIST_MAN_SRM_MST_FN|DS03:EDP_SRM_LIST_MAN_SRM_STATUS_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveSRMList: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveSRMList");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "DataAnalysisManager";
      trSet.tranMethod = "saveSRMList";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_SRM_UPD_MAN_SRM_MST_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryMapList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mapList");
    const retSet2 = new ObjDataSet("appliedList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_SRM_LIST_MAN_MAP_MST_FN|DS03:EDP_SRM_LIST_MAN_MAP_SRM_LST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryReferenceFilesList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("atftList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryReferenceFilesList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SRM_LIST_MAN_ATFT_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  downloadAllReferenceFiles: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("downList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("downloadAllReferenceFiles");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SRM_LIST_MAN_ATFT_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      const resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      for(let i = 0; i < datarows.length; i++) {
        let downloadfile = new DownloadFile();
        downloadfile.data[0].FILE_ID = datarows[i].FILE_ID;
        downloadfile.data[0].SAVE_NAME = datarows[i].ATF_FILE_NAME;
        Store.dispatch("common/DownloadFileFromServer", downloadfile);
      }
    });
  },
  queryRefFilesListFromRepo: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("atftRepoList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryRefFilesListFromRepo");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SRM_LIST_MAN_ATFT_MST_ALL_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveAddReferenceFiles: async ({ commit }, paramItems) => {
    for(let i = 0; i < paramItems.data.length; i++) {
      if(paramItems.data[i].SYSSTATUS == 'I' && paramItems.data[i].ADDBY == 'LOCAL') {
        // Local에서 업로드 하는 파일들만 먼저 서버에 업로드 하기
        let uploadfile = new UploadFile();
        uploadfile.data[0].DIV_KUBUN = 'ASSET';
        uploadfile.data[0].BIZ_KUBUN = 'FILE_ATFT';
        uploadfile.data[0].SITE_CODE = paramItems.data[i].CUST_ID;
        uploadfile.data[0].USER_KUBUN = $cookies.get('comp-id');
        uploadfile.data[0].SUB_DIR = '';
        uploadfile.data[0].RENAME_YN = 'Y';
        uploadfile.data[0].FILE_NAME = paramItems.data[i].file.name;
        uploadfile.data[0].file = paramItems.data[i].file;
        // Upload EDI File Data
        const retSet = new ObjDataSet("UploadedFile");
        let condSet = new ObjDataSet("condSet");
        let trSet = new ObjTrSet("saveAddReferenceFiles");
        condSet = appUtil.addDataHeader(uploadfile, condSet);
        trSet.AddDataSet("I", "DS01", condSet);
        trSet.AddDataSet("O", "DS02", retSet);
        trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
        const formData = new FormData();
        formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
        formData.append('trSet', JSON.stringify(trSet));
        await api.trFileSend("Fileupload", formData).then(res => {
          let resdata = res.data;
          var trset = JSON.parse(JSON.stringify(resdata));
          var datasets = trset.DataSets;
          var datarows = datasets[0].DataRows;
          //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
          paramItems.data[i].FILE_ID = datarows[0].FILE_NAME;  // Server file ID
        });
      } // if(paramItems.data[i].SYSSTATUS == 'I' && paramItems.data[i].ADDBY == 'LOCAL')
    } // for

    // Load일 경우 파일을 Copy하기 위해 서버에 디렉토리 설정을 위해 UploadFile객체 같이 보내기
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_ATFT';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('comp-id');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = '';
    uploadfile.data[0].file = '';
    let fileSet = new ObjDataSet("fileSet");
    fileSet = appUtil.addDataHeader(uploadfile, fileSet);
    /////////////////////////
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveAddReferenceFiles");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("I", "DS02", fileSet);
    trSet.tranID = "ResourceManager";
    trSet.tranMethod = "saveAddReferenceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryFlatFileLayoutList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("ffList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryFlatFileLayoutList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SRM_LIST_MAN_FFLAY_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  generateMap: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("generateMap");
    const trSet = new ObjTrSet("generateMap");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "GenMapManager";
    trSet.tranMethod = "generateMap";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commit('genMapFlag', 'successful');
    })
    .catch(error => {
      commit('genMapFlag', 'failed');
   });
  },
  deleteSRMListProcData: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteSRMListProcData");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "deleteSRMListProcData";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
};

const mutations = {
  mainGrid (state, datarows) {
    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      // console.log("filters : ", filters);
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.mainGrid = datarows;
    state.mainGridSource = datarows;
    state.arrFilter = arrFilter;
  },
  mainGridFilter (state, datarows) {
    let data = [];
    for (let i = 0; i < datarows.length; i++) {
      let item = datarows[i];
      if (!item.hidden) {
        data.push(item);
      }
    }
    datarows = data;

    datarows = datarows.sort((a ,b) => {
      let propa = a.LAY_PRCS_NO;
      let propb = b.LAY_PRCS_NO;
      if (propa > propb) {
        return 1;
      } else if (propa < propb) {
        return -1;
      }
      return 0;
    });
    let arrFilter = [];
    for (let i = 0; i < datarows.length; i++) {
      let rowitem = datarows[i];
      if (rowitem.LAY_PRCS_NO == null) {
        continue;
      }
      let filters = arrFilter.filter((item) => {
        return item.LAY_PRCS_NO == rowitem.LAY_PRCS_NO;
      });
      // console.log("filters : ", filters);
      if (filters.length == 1) {
        let item = filters[0];
        item.count = item.count + 1;
      } else {
        let obj = Object.assign({}, rowitem);
        arrFilter.push({
          index : i,
          LAY_PRCS_NO : obj.LAY_PRCS_NO,
          count : 1
        })
      }
    }
    state.arrFilter = arrFilter;
    state.mainGrid = datarows;
  },
  sortMapList (state, colSort, searchBy) {
    let datarows = state.mainGridSource;
    let {col, sort} = colSort;
    state.sort = {
      type: sort,
      searchBy: searchBy
    };
    
    if (state.sort && state.sort.searchBy !== '') {
      datarows = [...state.mainGrid];
    }
    
    if (sort === 'reset') {
      state.mapList = [...state.mainGridSource];
      state.mapSortList = [...state.mainGridSource];
      if (state.sort && state.sort.searchBy !== '') {
        state.mapList = [...state.mainGrid];
        state.mapSortList = [...state.mainGrid];
      }
      return;
    }

    datarows.sort((a ,b) => {
      return compareSort(a[col], b[col], sort);
    });

    state.mainGrid = [...datarows];
  },
  'RESET_FILTER_AND_SORT' (state) {
    if (state.sort) {
      state.sort.type = 'reset';
    }
    if (state.filter) {
      state.filter.str = '';
    }
  },
  'SET_MAP_FILTER'(state, params) {
    let comp = params.comp;
    let locked = params.locked;
    let search = params.search;
    let arrFilter = state.mapFixed;
    if (comp != undefined && comp != '') {
      arrFilter = arrFilter.filter((item) => {
        return item.MST_CUST_ID == comp;
      });
    }
    if (locked != undefined && locked != '') {
      arrFilter = arrFilter.filter((item) => {
        return item.MAP_MAPP_CHKIN_YN == locked;
      });
    }
    if (search != undefined && search != '') {
      arrFilter = arrFilter.filter((item) => {
        for (const prop in item) {
          if (typeof item[prop] == 'string') {
            let propValue = item[prop].toLowerCase();
            let queryValue = search.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[prop] == 'number') {
            let propValue = item[prop].toString().toLowerCase();
            let queryValue = search.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }
      });
    }
    state.mapList = arrFilter;
  },
  statusList (state, datarows) {
    state.statusList = datarows;
  },
  mapList (state, datarows) {
    state.mapList = datarows;
    state.mapFixed = datarows;
  },
  appliedList (state, datarows) {
    state.appliedList = datarows;
  },
  atftList (state, datarows) {
    state.atftList = datarows;
  },
  atftRepoList (state, datarows) {
    state.atftRepoList = datarows;
  },
  ffList (state, datarows) {
    state.ffList = datarows;
  },
  genMapFlag (state, genMapFlag) {
    state.genMapFlag = genMapFlag
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};

